// extracted by mini-css-extract-plugin
export default {"inputs_wrapper":"Tt","name_input":"Ut","full_width_input":"Vt","mobile_input":"Wt","input_styles":"Xt","mobile_input_wrapper":"Yt"};
    if(module.hot) {
      // 1713361644052
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  